export default __webpack_public_path__ + "static/salesforce-c8ced7a3bd1f68dc5376dfab0610e4a6.png";